var React = require('react');

function Minimize (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"}));
}

Minimize.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-minimize"};

module.exports = Minimize;

Minimize.default = Minimize;
